import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { useViewMode } from '@/stores/viewMode'
import { useMe } from './useMe'
import { Announcement } from './useAnnouncements'

interface ActiveAnnouncementsResponse {
  success: boolean
  data: Announcement[]
}

export function useActiveAnnouncements() {
  const { token } = useAuth()
  const { mode, id: viewModeId } = useViewMode()
  const { user } = useMe()

  // Provider/sys_admin 用戶不需要取得公告
  const isAdminUser = user?.role_type === 'sys_admin' || user?.scopes?.provider_id != null

  // 根據 viewMode 組出 query params
  const queryParams = new URLSearchParams()
  if (viewModeId) {
    if (mode === 'provider') {
      queryParams.set('providerId', String(viewModeId))
    } else if (mode === 'clinic' || mode === 'clinic_group') {
      queryParams.set('clinicId', String(viewModeId))
      queryParams.set('mode', 'clinic')
    } else if (mode === 'ad' || mode === 'ad_supplier_group') {
      queryParams.set('supplierId', String(viewModeId))
      queryParams.set('mode', 'ad_supplier')
    }
  }
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : ''

  // Admin 用戶不發送請求，避免不必要的 API 呼叫
  const shouldFetch = token && viewModeId && !isAdminUser

  const { data, error, mutate } = useGet<ActiveAnnouncementsResponse>(
    shouldFetch ? `/api/announcements/active${queryString}` : null,
    undefined,
    token ?? '',
  )

  return {
    announcements: data?.data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
